'use strict';

export { default as ReportFactory } from './report.factory';